var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{class:_vm.formClass},[_vm._t("default",null,null,{
      loadingConfig: _vm.loadingConfig,
      fields: _vm.fields,
      methods: {},
    })],2)}
var staticRenderFns = []

export { render, staticRenderFns }